import { render, staticRenderFns } from "./ReportControls.vue?vue&type=template&id=33d15a72&"
import script from "./ReportControls.vue?vue&type=script&lang=js&"
export * from "./ReportControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d15a72')) {
      api.createRecord('33d15a72', component.options)
    } else {
      api.reload('33d15a72', component.options)
    }
    module.hot.accept("./ReportControls.vue?vue&type=template&id=33d15a72&", function () {
      api.rerender('33d15a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportTable/ReportControls.vue"
export default component.exports